export const IS_MCDAN_ENV = process.env.REACT_APP_ENV === "mcdan";
export const IS_DEV_ENV =
  process.env.REACT_APP_ENV === "dev" ||
  process.env.REACT_APP_ENV === "dev-aws" ||
  process.env.REACT_APP_ENV === "local";
export const IS_RESEARCH_ENV = process.env.REACT_APP_ENV === "research";
export const IS_GATHER_ENV = process.env.REACT_APP_ENV === "gather";
export const IS_PROD_ENV =
  process.env.REACT_APP_ENV === "prod" || process.env.REACT_APP_ENV === "prod-aws";
export const IS_DEV_RESEARCH_ENV = IS_DEV_ENV || IS_RESEARCH_ENV;
export const IS_MCDAN_RESEARCH_ENV = IS_MCDAN_ENV || IS_RESEARCH_ENV;
export const IS_INTERNAL_ENV = IS_MCDAN_ENV || IS_DEV_ENV || IS_RESEARCH_ENV;
/**
 * The Novi-hosted AWS environments, where EVA is presented as one application in
 * the Novi suite rather than as a product of its own. Decides the browser tab's
 * name and favicon; the app switcher and brand lockup key off IS_SSO_BRIDGE
 * instead, which is the narrower question of whether the suite is reachable.
 */
export const IS_AWS_ENV =
  process.env.REACT_APP_ENV === "dev-aws" || process.env.REACT_APP_ENV === "prod-aws";
// Novi Auth SSO bridge (AWS): the edge owns identity, so EVA's native auth UI
// (user management, change password, sign out, 2FA) is hidden when this is set.
export const IS_SSO_BRIDGE = process.env.REACT_APP_SSO_BRIDGE === "true";
// Novi customer-management, which owns which applications a user may reach. Only
// deployed in the SSO-bridge environments, so it is undefined everywhere else and
// the app switcher that depends on it stays hidden.
export const CUSTOMER_MANAGEMENT_SERVICE_ADDRESS =
  process.env.REACT_APP_CUSTOMER_MANAGEMENT_SERVICE;
export const SAM_SERVICE_URI = process.env.REACT_APP_SAM_CHART_SERVICE;

export const GEO_MAP_SERVICE_ADDRESS = process.env.REACT_APP_GEO_MAP_SERVICE;
export const MAP_SERVICE_ADDRESS = process.env.REACT_APP_MAP_SERVICE;
export const MAP_RS_SERVICE_ADDRESS = process.env.REACT_APP_MAP_RS_SERVICE;
export const VIS_SERVICE_ADDRESS = process.env.REACT_APP_VIS_SERVICE;
export const PAD_SCENARIO_SERVICE_ADDRESS = process.env.REACT_APP_PAD_SCENARIO_SERVICE;
export const FORECASTING_SERVICE_ADDRESS = process.env.REACT_APP_FORECASTING_SERVICE;
export const DATA_SVC_RS_ADDRESS = process.env.REACT_APP_DATA_RS_ROOT;
// Aurora-only endpoint for syncing
export const SYNC_SVC_ADDRESS = process.env.REACT_APP_SYNC_SERVICE;
// New endpoint for supporting client sync
export const CLIENT_SYNC_SVC_ADDRESS = process.env.REACT_APP_CLIENT_SYNC_SERVICE;
export const PERFORMANCE_CALCULATION_SERVICE =
  process.env.REACT_APP_PERFORMANCE_CALCULATION_SERVICE;
export const PROJECT_SERVICE_ADDRESS = process.env.REACT_APP_PROJECT_SERVICE;

export const AUTOMATION_SERVICE_ADDRESS = process.env.REACT_APP_AUTOMATION_SERVICE;

export const EMPTY_FILTER_ID = "empty-filter-id";
export const CLEAR_MAP_ID = "clear";
export const DEFAULT_MIDSTREAM_SETTINGS = true;
export const SERIES_LIMIT_EXCEEDED = "Series Limit Exceeded";
/** What the data service writes for a field it has no value for. */
export const NOT_AVAILABLE = "n/a";

/** Which unit the shapefile buffer box was last typed in. */
// The "-2" retires choices remembered from the four-unit dropdown this switch
// replaced, so every reader starts on the pair's larger unit.
export const SHAPEFILE_BUFFER_UNIT_LOCAL_STORAGE_KEY = "shapefile-buffer-unit-2";

export const MCDAN_ORG_ID = "d1b602c9-4a47-4f89-b7ea-fedb6937b1ab";
export const ARPS_INPUT_FIELD_NAME = "ArpsInputField";

export const EVA_RESEARCH_NAME = "EVA Research";

/** Support address surfaced to users in error states. */
export const SUPPORT_EMAIL = "support@novilabs.com";

export const DEFAULT_PRECISION_ADJUSTMENT = 0;
